<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(1,rowKey.data)" :disabled="!permissionChecker('OrderRule.Edit')">编辑</a>
        </span>
      </template>

    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-orderRule-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-orderRule-add>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageOrderRuleAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageOrderRuleAdd
  },
  data() {
    return {
      filter: [
        {
          type: "select",
          key: "orderType",
          name: "订单类型",
          options: [
            { name: "标准订单", val: 0 },
            { name: "定制订单", val: 1 },
            { name: "促销订单", val: 2 }
          ]
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "订单类型",
          width: 180,
          dataIndex: "orderType",
          customRender: (text, row, index) => {
            return row.orderTypeStr;
          }
        },
        {
          title: " 分部审核",
          dataIndex: "branchAudit",
          customRender: (text, row, index) => {
            return row.branchAudit ? "是" : "否";
          }
        },
        {
          title: " 总部审核",
          dataIndex: "headAudit",
          customRender: (text, row, index) => {
            return row.headAudit ? "是" : "否";
          }
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { orderType: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      permissionArray: [],
      title: ""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
    this.permissionArray = this.getPermission("OrderRule");
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.orderType = p.values.orderType;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑订单规则";
      } else if (type == 2) {
        this.title = "订单规则详情";
        this.isabl = true;
      } else {
        this.title = "新增订单规则";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetOrderRuleList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderRule/List.vue